import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  GET_COMPANY_MANIFEST_QUERY_KEY,
  CompanyManifestResponseDto,
  useConfigurationQuery,
  useCompanySettingsQuery,
} from 'theSource/queries';
import { LogoStyled } from './LogoStyled';
import { ROUTES } from 'theSource/app/routes';

export interface LogoProps {
  onLoad?: () => void;
}

export const Logo = ({ onLoad }: LogoProps) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const manifestData: CompanyManifestResponseDto = queryClient.getQueryData(
    GET_COMPANY_MANIFEST_QUERY_KEY
  )!;

  const { configuration } = useConfigurationQuery();
  const { companySettings } = useCompanySettingsQuery({
    enabled: Boolean(configuration?.apiHost),
  });

  const sourceEnabled = companySettings?.data.source_license;

  const enrollmentRoute = useSelector(
    (state: any) => state?.enrollment?.authentication?.redirectLink
  );

  const navigateToHome = (event: React.MouseEvent<HTMLImageElement>) => {
    if (sourceEnabled) {
      if (enrollmentRoute?.includes('enrollment')) {
        event.currentTarget.setAttribute('data-bs-toggle', 'modal');
        event.currentTarget.setAttribute(
          'data-bs-target',
          '#closeEnrollment-popover'
        );
        if (!event?.isTrusted) {
          return;
        }
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        });
        event.currentTarget.dispatchEvent(clickEvent);
      } else {
        navigate(ROUTES.main.home.path);
      }
    } else {
      navigate(ROUTES.enrollment.path);
    }
  };

  return (
    <LogoStyled
      src={manifestData?.logo}
      alt={manifestData?.name}
      data-testid="logo"
      onLoad={onLoad}
      onClick={navigateToHome}
      role="button"
      aria-label={t('home')}
      tabIndex={0}
    />
  );
};
